import React from 'react';
import ReactDOMClient from 'react-dom/client';
import singleSpaReact from 'single-spa-react';
import RemoteAppProps, { RemoteAppPropsClient } from '../../../types/RemoteAppProps';

// eslint-disable-next-line
const getComponentProps = (props: Record<string, any>) => {
  // eslint-disable-next-line
  let compProps: Record<string, any> = {};
  Object.keys(props).forEach((key) => {
    if (key !== 'mountParcel' && key !== 'name' && key !== 'singleSpa' && typeof props[key] === 'object') {
      compProps = {
        ...compProps,
        ...props[key]
      };
    } else {
      compProps[key] = props[key];
    }
  });
  return compProps;
};

const withPropManipulation = (Comp: React.FC<RemoteAppProps>, customProps = {}) => {
  // eslint-disable-next-line
  return (props: any) => {
    const compProps = getComponentProps(props) as RemoteAppProps;
    return (
      <Comp
        {...compProps}
        {...customProps}
      />
    );
  };
};

export const withSingleSpaAsync = (
  Comp: React.FC<RemoteAppProps>,
  isCreateRoot: boolean,
  loadDependencies?: (props: RemoteAppPropsClient) => Promise<Record<string, object>>
) => {
  const lifecycles = singleSpaReact({
    React,
    ReactDOMClient,
    // eslint-disable-next-line
    loadRootComponent: async (props: any) => {
      const comProps = getComponentProps(props);
      let loaded = {};
      if (loadDependencies) {
        loaded = await loadDependencies(comProps as RemoteAppPropsClient);
      }
      return withPropManipulation(Comp, loaded);
    },
    renderType: isCreateRoot ? 'createRoot' : 'hydrateRoot'
  });

  const bootstrap = lifecycles.bootstrap;
  const mount = lifecycles.mount;
  const unmount = lifecycles.unmount;

  return {
    bootstrap,
    mount,
    unmount
  };
};
